
import { GLOBAL_QUOTATION_SET_STEP, GLOBAL_QUOTATION_SET_STEPER_SELECTED, GLOBAL_QUOTATION_RESET_STATE_GLBALS } from 'Redux/types/globalQuotationTypes';


const initianState = {
  step: null, // Define el paso en el que están en la cotización
  steperSelected: 0, // Define en los Steps mostrados al user, cuál es el seleccionado
};

const globalsReducer = (state = initianState, actions) => {
  switch (actions.type) {
    case GLOBAL_QUOTATION_SET_STEP:
      return {
        ...state,
        step: actions.step,
      };

    case GLOBAL_QUOTATION_SET_STEPER_SELECTED:
      return {
        ...state,
        steperSelected: actions.steperSelected,
      };

    case GLOBAL_QUOTATION_RESET_STATE_GLBALS:
      return {
        ...state,
        ...initianState,
        ...actions.defaults,
      };

    default:
      return state;
  }
};

export default globalsReducer;
